import api from "@/lib/api";

let cache = null;

/** Busca depoimentos aprovados (público). Resultado cacheado em módulo. */
export function fetchTestimonials() {
    if (!cache) {
        cache = api
            .get("/api/testimonials")
            .then(({ data }) => data)
            .catch(() => []);
    }
    return cache;
}

export function clearTestimonialsCache() {
    cache = null;
}
